export interface Reaction {
  id: string
  emoji: string
  from: string
  fromLabel?: string
}

interface MessageReactionsProps {
  messageId: string
  reactions: Reaction[]
  myReactionEmoji?: string
  onToggleReaction?: (emoji: string) => void
}

export function MessageReactions({
  messageId: _messageId,
  reactions,
  myReactionEmoji,
  onToggleReaction,
}: MessageReactionsProps) {
  if (!reactions || reactions.length === 0) return null

  const grouped = reactions.reduce((acc, reaction) => {
    if (!acc[reaction.emoji]) {
      acc[reaction.emoji] = {
        emoji: reaction.emoji,
        count: 0,
        users: [] as string[],
        hasMine: false,
      }
    }
    acc[reaction.emoji].count += 1
    acc[reaction.emoji].users.push(reaction.fromLabel || reaction.from)
    if (reaction.emoji === myReactionEmoji) {
      acc[reaction.emoji].hasMine = true
    }
    return acc
  }, {} as Record<string, { emoji: string; count: number; users: string[]; hasMine: boolean }>)

  if (Object.keys(grouped).length === 0) return null

  return (
    <div className="flex flex-wrap gap-1 mt-1">
      {Object.values(grouped).map(({ emoji, count, users, hasMine }) => (
        <button
          key={emoji}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onToggleReaction?.(emoji)
          }}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs transition-all active:scale-95 cursor-pointer ${
            hasMine
              ? 'bg-emerald-100 hover:bg-emerald-200 border border-emerald-300 text-emerald-900 font-semibold ring-1 ring-emerald-400/40 shadow-xs'
              : 'bg-gray-100 hover:bg-gray-200 border border-transparent text-gray-700'
          }`}
          title={`${users.join(', ')}${hasMine ? ' (Haz clic para quitar tu reacción)' : ' (Haz clic para reaccionar)'}`}
        >
          <span>{emoji}</span>
          {count > 1 && (
            <span className={hasMine ? 'text-emerald-700 font-bold' : 'text-gray-600'}>
              {count}
            </span>
          )}
        </button>
      ))}
    </div>
  )
}
